import {
  FaBolt,
  FaBookOpen,
  FaBus,
  FaChalkboardTeacher,
  FaChartPie,
  FaClipboardList,
  FaCogs,
  FaEdit,
  FaFolderOpen,
  FaGlobe,
  FaGraduationCap,
  FaIdBadge,
  FaLaptop,
  FaMapMarkerAlt,
  FaMobileAlt,
  FaRupeeSign,
  FaSearch,
  FaShieldAlt,
  FaUserFriends,
  FaVideo,
  FaWallet,
  FaWhatsapp,
  FaWpforms,
} from 'react-icons/fa';

const iconMap = {
  school: FaGraduationCap,
  admin: FaClipboardList,
  people: FaUserFriends,
  finance: FaRupeeSign,
  phone: FaMobileAlt,
  book: FaChalkboardTeacher,
  chart: FaChartPie,
  bus: FaBus,
  video: FaVideo,
  folder: FaFolderOpen,
  quiz: FaBookOpen,
  shield: FaShieldAlt,
  devices: FaLaptop,
  feed: FaWpforms,
  edit: FaEdit,
  search: FaSearch,
  chat: FaWhatsapp,
  badge: FaIdBadge,
  pin: FaMapMarkerAlt,
  pay: FaWallet,
  cog: FaCogs,
  globe: FaGlobe,
  bolt: FaBolt,
};

function HomeIcon({ name, size = 28 }) {
  const Icon = iconMap[name] || FaGraduationCap;
  return <Icon size={size} aria-hidden="true" />;
}

export default HomeIcon;
